<template>
    <div>
        <transition name="slide-fade">
            <form
                id="form-cont"
                :action="rutaformulario"
                method="POST"
                class="mt-3 zp-errors-border-all"
                @submit.prevent="sendForm"
                v-show="mostrarFormulario"
            >
                <input type="hidden" name="_token" :value="csrf" />
                <div class="form-group">
                    <input
                        type="text"
                        name="nombre"
                        placeholder="Nombre"
                        :class="
                            !$v.form.nombre.$anyError
                                ? 'form-control zp-input-formulario'
                                : 'form-control zp-input-formulario zp-form-error'
                        "
                        v-model="$v.form.nombre.$model"
                        @keypress="onlyLetters"
                        required
                        autocomplete="off"
                    />
                    <div
                        class="zp-texto-error p-0"
                        v-if="$v.form.nombre.$dirty"
                    >
                        <span
                            v-if="!$v.form.nombre.required"
                            class="zp-error-span"
                        >
                            <i
                                class="fas fa-exclamation-circle text-danger"
                            ></i>
                            Campo necesario
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <input
                        type="text"
                        name="rut"
                        placeholder="RUT"
                        :class="
                            !$v.form.rut.$anyError
                                ? 'form-control zp-input-formulario'
                                : 'form-control zp-input-formulario zp-form-error'
                        "
                        v-model="$v.form.rut.$model"
                        required
                        autocomplete="off"
                        maxlength="12"
                        v-rut:live
                    />
                    <div class="zp-texto-error p-0" v-if="$v.form.rut.$dirty">
                        <span
                            v-if="!$v.form.rut.required"
                            class="zp-error-span"
                        >
                            <i
                                class="fas fa-exclamation-circle text-danger"
                            ></i>
                            Campo necesario
                        </span>
                        <span
                            v-if="
                                (!$v.form.rut.rutValidation ||
                                    !$v.form.rut.minLength) &&
                                $v.form.rut.required
                            "
                            class="zp-error-span"
                        >
                            <i
                                class="fas fa-exclamation-circle text-danger"
                            ></i>
                            R.U.N. inválido
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        :class="
                            !$v.form.email.$anyError
                                ? 'form-control zp-input-formulario'
                                : 'form-control zp-input-formulario zp-form-error'
                        "
                        v-model="$v.form.email.$model"
                        required
                    />
                    <div class="zp-texto-error p-0" v-if="$v.form.email.$dirty">
                        <span
                            v-if="!$v.form.email.required"
                            class="zp-error-span"
                        >
                            <i
                                class="fas fa-exclamation-circle text-danger"
                            ></i>
                            Campo necesario
                        </span>
                        <span
                            v-else-if="!$v.form.email.email"
                            class="zp-error-span"
                        >
                            <i
                                class="fas fa-exclamation-circle text-danger"
                            ></i>
                            Debe ser un email valido
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <input
                        type="text"
                        name="telefono"
                        maxlength="9"
                        placeholder="Teléfono"
                        :class="
                            !$v.form.telefono.$anyError
                                ? 'form-control zp-input-formulario'
                                : 'form-control zp-input-formulario zp-form-error'
                        "
                        v-model="$v.form.telefono.$model"
                        @keypress="onlyNumber"
                        required
                    />
                    <div
                        class="zp-texto-error p-0"
                        v-if="$v.form.telefono.$dirty"
                    >
                        <span
                            v-if="!$v.form.telefono.required"
                            class="zp-error-span"
                        >
                            <i
                                class="fas fa-exclamation-circle text-danger"
                            ></i>
                            Campo necesario
                        </span>
                        <span
                            v-if="!$v.form.telefono.minLength"
                            class="zp-error-span"
                        >
                            <i
                                class="fas fa-exclamation-circle text-danger"
                            ></i>
                            Formato inválido
                        </span>
                    </div>
                </div>
                <button
                    type="submit"
                    class="btn btn-block bg-main-color general-btn my-4 text-white"
                    :disabled="$v.form.$invalid"
                >
                    {{ btnText }}
                </button>
            </form>
        </transition>
    </div>
</template>

<script>
import {
    required,
    minLength,
    email,
    requiredIf
} from 'vuelidate/lib/validators'
import { rutValidator, rutInputDirective } from 'vue-dni'
Vue.directive('rut', rutInputDirective)

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
Vue.component('v-select-c', vSelect)

export default {
    name: 'FormularioContactoProyecto',
    props: ['rutaformulario', 'unidades', 'proyectoslug' , 'proyectoid'],
    data: function () {
        return {
            mostrarFormulario: true,
            formularioCargando: false,
            btnText: 'COTIZAR',
            form: {
                nombre: '',
                email: '',
                telefono: '',
                rut: ''
            },
            tipologias: [],
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute('content')
        }
    },
    validations: {
        form: {
            nombre: {
                required
            },
            email: {
                required,
                email
            },
            telefono: {
                required,
                minLength: minLength(9)
            },
            rut: {
                required,
                rutValidation: rutValidator,
                minLength: minLength(9)
            }
        }
    },
    watch: {},
    mounted () {
        this.calculaTipologias()
    },
    methods: {
        calculaTipologias () {
            this.unidades.map(p => {
                if (
                    this.tipologias.indexOf(
                        p.dormitorios + ' Dorm ' + p.banos + ' Baños'
                    ) === -1
                ) {
                    this.tipologias.push(
                        p.dormitorios + ' Dorm ' + p.banos + ' Baños'
                    )
                }
            })
        },
        sendForm () {
            if (!this.formularioCargando) {
                this.formularioCargando = true
                this.btnText = 'COTIZANDO...'
                const ruta = `/proyecto/${this.proyectoid}/${this.proyectoslug}/contacto-proyecto`
                $('#form-cont').attr('action', ruta).submit()
            }
        },
        onlyNumber ($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                $event.preventDefault()
            }
        },
        onlyLetters ($event) {
            var regex = new RegExp('^[a-zA-Z ñÑ]+$')
            var key = String.fromCharCode(
                !$event.charCode ? $event.which : $event.charCode
            )
            if (!regex.test(key)) {
                $event.preventDefault()
                return false
            }
        }
    }
}
</script>
